export const selectVendorScore = state => state.vendorScore || {}
